import { render, staticRenderFns } from "./GenericItem.vue?vue&type=template&id=2726dfc6&scoped=true"
import script from "./GenericItem.vue?vue&type=script&lang=js"
export * from "./GenericItem.vue?vue&type=script&lang=js"
import style0 from "./GenericItem.vue?vue&type=style&index=0&id=2726dfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726dfc6",
  null
  
)

export default component.exports